import { render, staticRenderFns } from "./catalog-filters.vue?vue&type=template&id=94388e4e&scoped=true"
import script from "./catalog-filters.vue?vue&type=script&lang=js"
export * from "./catalog-filters.vue?vue&type=script&lang=js"
import style0 from "./catalog-filters.vue?vue&type=style&index=0&id=94388e4e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94388e4e",
  null
  
)

export default component.exports